import type { UtilityContext } from '@change-corgi/core-react/utilityContext';

import {
	SubscriptionPaymentMethod,
	type SubscriptionPaymentMethodQuery,
	type SubscriptionPaymentMethodQueryVariables,
} from './subscriptionPaymentMethod.graphql';

export type UpdatePaymentMethodResult =
	| {
			success: false;
	  }
	| {
			success: true;
			paymentMethod: NonNullable<
				NonNullable<SubscriptionPaymentMethodQuery['viewer']>['user']
			>['subscriptions'][0]['paymentMethod'];
	  };

export async function updatePaymentMethod({
	errorReporter,
	gql: { fetch },
}: UtilityContext): Promise<UpdatePaymentMethodResult> {
	try {
		const { data } = await fetch<SubscriptionPaymentMethodQuery, SubscriptionPaymentMethodQueryVariables>({
			query: SubscriptionPaymentMethod,
			rejectOnError: true,
		});
		if (!data.viewer.user) {
			const err = new Error('User not found when updating payment method');
			void errorReporter.report(err);
			throw err;
		}
		if (!data.viewer.user.subscriptions.length) {
			const err = new Error('Subscription not found when updating payment method');
			void errorReporter.report(err);
			throw err;
		}
		return {
			success: true,
			paymentMethod: data.viewer.user.subscriptions[0].paymentMethod,
		};
	} catch (e) {
		return { success: false };
	}
}
